import React from 'react';
import { View, StyleSheet, Image } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { Text, Button, Theme } from '../../components/ui';
import { AuthStackParamList } from '../../navigation/AuthNavigator';

type SplashScreenNavigationProp = NativeStackNavigationProp<AuthStackParamList, 'Splash'>;

const SplashScreen: React.FC = () => {
  const navigation = useNavigation<SplashScreenNavigationProp>();

  const handleGetStarted = () => {
    navigation.navigate('Register');
  };
  
  return (
    <SafeAreaView style={styles.safeArea}>
      <View style={styles.container}>
        {/* Background Image */}
        <Image
          source={require('../../assets/onboarding/first-page.webp')}
          style={styles.backgroundImage}
          resizeMode="cover"
        />
        
        {/* Main content area */}
        <View style={styles.contentArea}>
          <View style={styles.textContainer}>
            <Text variant="heading1" align="center" style={styles.title}>
              Your personalized Mentor
            </Text>
            <Text variant="body1" color="secondary" align="center" style={styles.subtitle}>
              That knows all the self-help and business books and provides you the knowledge that perfectly matches your needs.
            </Text>
          </View>
        </View>

        {/* Get Started button sticky to bottom */}
        <View style={styles.buttonContainer}>
          <Button
            title="Get Started"
            onPress={handleGetStarted}
            style={styles.getStartedButton}
          />
        </View>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: '#DDECEE',
  },
  container: {
    flex: 1,
    backgroundColor: '#DDECEE',
  },
  backgroundImage: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    height: 400,
    opacity: 0.9,
  },
  contentArea: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: Theme.spacing.xxl,
    paddingTop: Theme.spacing.xxxxl,
    zIndex: 1,
  },
  textContainer: {
    gap: Theme.spacing.xl,
    maxWidth: '100%',
    alignItems: 'center',
  },
  title: {
    fontFamily: Theme.typography.fontFamily.semiBold,
    fontSize: 32,
    lineHeight: 40,
    color: Theme.colors.textPrimary,
  },
  subtitle: {
    fontFamily: Theme.typography.fontFamily.regular,
    fontSize: 18,
    lineHeight: 26,
    textAlign: 'center',
    paddingHorizontal: Theme.spacing.md,
  },
  buttonContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    paddingHorizontal: Theme.spacing.xxl,
    paddingBottom: Theme.spacing.xxxxl,
    paddingTop: Theme.spacing.xl,
    zIndex: 2,
  },
  getStartedButton: {
    // Default button styling from theme
  },
});

export default SplashScreen; 